export default __webpack_public_path__ + "static/media/iste3.ebffd264.png";